module.exports = __webpack_public_path__ + "img/devices_3_768.f350f47.jpg";